import styled from '@emotion/styled';
import { Modal, Select } from 'antd';
import tw from 'twin.macro';

//adding overflow hidden for the dropdown border to appear clearly
export const CustomSelect = styled(Select)`
    ${tw`border border-purpleFont rounded text-[13px] text-headerColor`}
    .ant-select-selector {
        height: 100% !important;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        border: none !important;
    }
    .ant-select-arrow {
        ${tw`text-headerColor`}
    }
    overflow: hidden;
`;

export const CustomModal = styled(Modal)`
.ant-modal-header {
    ${tw`bg-purpleFont`}
}
.ant-modal-title {
    ${tw`text-white`}
}
.ant-modal-close-x span svg {
    fill: white;
}
.ant-modal-body {
    ${tw`p-0 mt-5`}
}
`;
